import { useState } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const FAQS = [
  {
    q: "Is the consultation really free?",
    a: "Yes. The initial 30-minute consultation is a conversation led by Brown & Associates to learn about your business, your bookkeeping concerns, and the type of assistance you may need. It does not include reviewing your accounting file, correcting transactions, or providing detailed bookkeeping advice.",
  },
  {
    q: "Will you review my books during the free consultation?",
    a: "No. The consultation helps determine what kind of assistance you may need. If your accounting file requires investigation, a paid Books Diagnostic + Action Plan may be recommended.",
  },
  {
    q: "Do I have to purchase a diagnostic?",
    a: "No. A diagnostic is recommended only when a closer review is necessary to determine what is wrong or properly define the scope of cleanup work.",
  },
  {
    q: "Does the diagnostic include correcting my books?",
    a: "No. The diagnostic identifies the problems and provides an action plan. Any cleanup or correction work is quoted separately.",
  },
  {
    q: "Can Brown & Associates provide ongoing bookkeeping?",
    a: "Yes. Monthly bookkeeping may be recommended when it is the appropriate solution for your business.",
  },
];

export const FAQ = () => {
  const [value, setValue] = useState(undefined);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-warm-neutral py-24 md:py-32"
    >
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-navy-700 mb-5">
            Good to know
          </p>
          <h2 className="font-heading font-semibold text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-navy-900">
            Questions,{" "}
            <span className="italic font-normal">answered.</span>
          </h2>
        </Reveal>

        <div className="lg:col-span-8">
          <Reveal>
            <AccordionPrimitive.Root
              type="single"
              collapsible
              value={value}
              onValueChange={setValue}
              className="border-t border-navy-900/15"
            >
              {FAQS.map((item, i) => (
                <AccordionPrimitive.Item
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-navy-900/15"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionPrimitive.Header className="flex">
                    <AccordionPrimitive.Trigger
                      data-testid={`faq-trigger-${i}`}
                      className="group flex flex-1 items-center justify-between gap-6 py-6 text-left font-heading text-xl sm:text-2xl text-navy-900 transition-colors duration-200 hover:text-navy-700 [&[data-state=open]>span>svg]:rotate-45"
                    >
                      {item.q}
                      <span className="shrink-0 inline-flex h-9 w-9 items-center justify-center rounded-full border border-navy-900/20">
                        <Plus
                          className="h-4 w-4 transition-transform duration-300"
                          aria-hidden="true"
                        />
                      </span>
                    </AccordionPrimitive.Trigger>
                  </AccordionPrimitive.Header>
                  <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
                    <p className="font-body text-base sm:text-lg leading-relaxed text-navy-900/70 pb-7 pr-12 max-w-2xl">
                      {item.a}
                    </p>
                  </AccordionPrimitive.Content>
                </AccordionPrimitive.Item>
              ))}
            </AccordionPrimitive.Root>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
